















// @ is an alias to /src
import {Component, Mixins} from "vue-property-decorator";
import ResetPassword from "@/components/auth/resetPassword.vue"
import ResetPasswordConfirm from "@/components/auth/resetPasswordConfirm.vue";
import ResetPasswordExpired from "@/components/auth/resetPasswordExpired.vue";
import userApi from "@/api/userApi";
import _ from "lodash";
import Authority from "@/common/mixins/authority";

@Component({
  name: 'ResetPasswordPage',
  components: {
    ResetPasswordExpired,
    ResetPasswordConfirm,
    ResetPassword,
  }
})
export default class ResetPasswordPage extends Mixins(Authority) {
  public isExpired = false;
  public isCompleted = false;
  public token: string;
  public username = '';
  public message = '';

  async mounted() {
    // Get token
    this.token = this.$route.params.token
    await this.verifyToken()
  }

  private async verifyToken():Promise<void> {
    // Call api verify token
    const response = await userApi.verifyToken(this.token);

    // If have then show PR 20 else PR 50
    if (_.get(response, 'meta.status') != 200) {
      this.isExpired = true;
      this.message = _.get(response, 'meta.message');
    } else {
      this.username = _.get(response, 'data.username');
    }
  }

  public submit() {
    this.isCompleted = true;
  }
};
